/*  MUI  */
import { Icon } from '@auviknetworks/iceberg-ui';
import { Box, Button, Grid, Paper, TableCell, Typography } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import { ManagedTable } from 'application/Shared/Components/Table';
import { FontSizes } from 'application/Shared/Constants';
import { Route } from 'application/Shared/Helpers';

/*  NPM  */
import i18n from 'i18n';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { withRouter } from 'router/withRouter';

const headers = [
    {
        align: 'left',
        field: 'name',
        renderHeader: <strong>{i18n.t('Common.name')}</strong>,
        sortable: true,
        sortableFieldType: 'string',
        sortableKey: 'name',
        width: '20%'
    },
    {
        align: 'left',
        field: 'description',
        renderHeader: <strong>{i18n.t('Common.description')}</strong>,
        sortable: true,
        sortableFieldType: 'string',
        sortableKey: 'description',
        width: '65%'
    },
    {
        align: 'right',
        field: 'enabled',
        renderHeader: <strong>{i18n.t('Common.actions')}</strong>,
        sortable: false,
        width: '15%'
    }
];

const searchFields = ['name', 'description'];

class Utilities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            options: []
        };
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unmount = true;
    }

    load = async () => {
        const { t, match } = this.props;
        const { partnerId } = match.params;
        const route = Route.buildBasePartnerRoute({ partnerId });

        let options = [
            {
                // Tag Editor
                action: t('Common.go'),
                description: t('Configure.tag_editor'),
                disabled: false,
                icon: <Icon size={FontSizes[4]} src="Tag1" />,
                key: 'tag_editor_card',
                name: t('Sidebar.tag_editor'),
                page: `${route}/tags`,
                permission: ['system_bulk_editor']
            }
        ];

        if (this.unmount) {
            return;
        }

        options = options.sort((a, b) => {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
            return 0;
        });

        if (!this.unmount) {
            this.setState({ loaded: true, options });
        }
    };

    renderRow = (row) => {
        const { t } = this.props;

        return (
            <>
                <TableCell>
                    <Box display="flex" alignItems="center">
                        <Box mr="4px">{row.icon}</Box>
                        <Box>{row.name}</Box>
                    </Box>
                </TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell style={{ textAlign: 'right' }}>
                    {row.external ? (
                        <a
                            target="_blank"
                            href={row.page}
                            rel="noopener noreferrer nofollow"
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                size="anmMedium"
                            >
                                {row.action}
                            </Button>
                        </a>
                    ) : (
                        <Link to={row.page}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="anmMedium"
                            >
                                {row.action}
                            </Button>
                        </Link>
                    )}
                    {row.disabled && (
                        <Typography size="small">
                            {t('Common.coming_soon')}
                        </Typography>
                    )}
                </TableCell>
            </>
        );
    };

    render() {
        const { loaded, options } = this.state;
        const { t } = this.props;

        return (
            <>
                <PageTitle title={t('Configure.title')} />
                <Paper elevation={0} variant="outlined">
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            {loaded && (
                                <ManagedTable
                                    headers={headers}
                                    renderBody={this.renderRow}
                                    renderBodyKey="name"
                                    renderFooter={false}
                                    rows={options}
                                    rowsPerPage={-1}
                                    searchEnabled
                                    searchFields={searchFields}
                                    sortDirection="ASC"
                                    sortFieldType="string"
                                    sortKey="name"
                                />
                            )}
                        </Grid>
                    </Grid>
                </Paper>
            </>
        );
    }
}
export default withRouter(withTranslation()(Utilities));
